// extracted by mini-css-extract-plugin
export default {"WelcomeHeading":"WelcomeHeading_WelcomeHeading__7C89i"};